/**
 * splitTime splits a string presented time like XX:XX into array of Numbers
 * @param s {String} expects string of the type XX:XX
 * @returns number[]
 */
export const splitTime = (s: string): number[] => s.split(":").map(x => parseInt(x));


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./helpers/SplitTime/SplitTime.ts